import { useEffect, useRef, useState } from "react";

const CHECK_DB_INTERVAL_IN_SECONDS = 2;
const MAX_CHECK_DB_ATTEMPTS = 1;
// const KEEP_DB_ALIVE_INTERVAL_IN_MIN = 10;

export const useIsDbAwake = () => {
  const [isDbAwake, setIsDbAwake] = useState(false);
  const [error, setError] = useState("");
  const attempts = useRef(0);

  useEffect(() => {
    const checkIfDbIsAwake = async () => {
      let result = {};
      try {
        console.log("API", process.env.REACT_APP_API_V2_URL);
        console.log("Checking DB... ", attempts.current + 1);
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/db_init`,
          {
            method: "GET",
          }
        );
        result = await response.json();
      } catch (err) {
        console.error(err.message);
        // setError(err.message ?? "Connection error");
      } finally {
        if (result?.isDbAwake) {
          setIsDbAwake(true);
        } else {
          if (attempts.current < MAX_CHECK_DB_ATTEMPTS) {
            attempts.current += 1;
            setTimeout(() => {
              checkIfDbIsAwake();
            }, CHECK_DB_INTERVAL_IN_SECONDS * 1000);
            return;
          }
          setError("Cloud App is not available. Try to reload the page.");
        }
      }
    };

    checkIfDbIsAwake();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (!isDbAwake) return;

  //   const interval = setInterval(async () => {
  //     await touchDb();
  //   }, KEEP_DB_ALIVE_INTERVAL_IN_MIN * 60 * 1000);

  //   // @ts-ignore
  //   return () => clearInterval(interval);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isDbAwake]);

  return {
    isDbAwake,
    error,
    setError,
  };
};
